export default __webpack_public_path__ + "static/media/bg3.40d6a20b.jpg";